import { render, staticRenderFns } from "./CheckBig.vue?vue&type=template&id=af356f8a&"
import script from "./CheckBig.vue?vue&type=script&lang=ts&"
export * from "./CheckBig.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports